import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ellipsis',
  standalone: true
})
export class EllipsisPipe implements PipeTransform {
  transform(val: string, maxLength: number): string {
    return val.ellipsis(maxLength);
  }
}
